<template>
  <!-- Future Self: Sorry for the inline styles, but the admin template stylesheet overwrites ANY margins and paddings with 0 :/ -->
  <div>
    <wizard
      :steps="['Fahrzeug wählen', 'Zubehör', 'Kunde', 'Kalkulation', 'Angebot']"
      :current-step="1"
    />

    <widget v-if="!type">
      <template slot="title">
        Fahrzeug wählen
      </template>
      <template slot="content">
        <div
          class="p-4"
          style="margin-bottom: 20px;"
        >
          <mia-notice
            permanent
            style="padding: 1rem; font-size: 1rem;"
          >
            Bitte wählen Sie ein Fahrzeug aus den folgenden Optionen aus:
          </mia-notice>
        </div>
        <div class="row">
          <div class="flex items-center justify-center choose">
            <button
              class="block w-64 text-base text-center text-white transition-colors duration-75 ease-out bg-blue-600 rounded shadow-lg hover:bg-blue-700"
              style="padding: 1.5rem 1rem;"
              @click="showSearchModal = true"
            >
              Fahrzeug aus dem <b>Bestand</b> heraussuchen
            </button>
            <h3 style="margin-left: 1.5rem; margin-right: 1.5rem;">
              oder
            </h3>
            <button
              class="block w-64 text-base text-center text-white transition-colors duration-75 ease-out bg-blue-600 rounded shadow-lg hover:bg-blue-700"
              style="padding: 1.5rem 1rem;"
              @click="type = 'external'"
            >
              <b>Externe Konfiguration</b> importieren<br>
              <small>(z.B. aus dem SEAT Konfigurator)</small>
            </button>
          </div>
        </div>
      </template>
    </widget>

    <template v-if="type === 'existing'">
      <car-search @done="nextStep" />
    </template>

    <template v-if="type === 'configurator'">
      <car-configurator
        use-phoenix
        @done="nextStep"
      />
    </template>

    <template v-if="type === 'external'">
      <external-configuration
        use-phoenix
        allow-custom-list-price
        @done="nextStep"
      />
    </template>


    <mia-search-cars-modal
      v-if="showSearchModal"
      @closed="showSearchModal = false"
      @select="onSelectCar"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import Notice from '@/components/cars/edit/Notice.vue'
import SearchCarsModal from '@/components/cars/SearchCarsModal.vue'

import Wizard from '../general/wizard.vue'
import Widget from '../general/widget.vue'

import CarSearch from './car-search.vue'
import CarConfigurator from '../configurator/standalone.vue'
import ExternalConfiguration from './external-configuration.vue'

export default {

  components: {
    Wizard,
    Widget,
    CarSearch,
    CarConfigurator,
    ExternalConfiguration,
    'mia-notice': Notice,
    'mia-search-cars-modal': SearchCarsModal
  },

  data() {
    return {
      type: false,
      showSearchModal: false
    }
  },

  computed: {
    ...mapGetters([
      'quickMethod'
    ])
  },

  methods: {
    ...mapActions([
      'storeQuickMethod'
    ]),

    nextStep() {
      this.$router.push({
        name: 'offers.accessories'
      })
    },

    sell() {
      this.storeQuickMethod('sell')
    },

    mediate() {
      this.storeQuickMethod('mediate')
    },

    onSelectCar(car) {
      console.log(car)
      this.showSearchModal = false
      this.$router.push(`/offer/sell/${car.id}`)
    }
  }

}

</script>

<style lang="scss" scoped>
    .choose {
        h3 {
            display: inline-block;
            vertical-align: middle;
            margin: 0 10px;
        }
    }
</style>
